"use client";

import React from "react";
import { motion } from "motion/react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

const defaultFaqs: FAQItem[] = [
  {
    question: "What is your typical project timeline?",
    answer: "Timelines vary based on complexity. A standard business website usually takes 1-2 weeks, while complex web applications or custom systems can take 4-8 weeks. I provide a detailed schedule during our discovery phase.",
  },
  {
    question: "Do you provide ongoing maintenance?",
    answer: "Yes! I offer monthly maintenance plans that include security updates, performance monitoring, backups, and minor content updates to ensure your platform stays in peak condition.",
  },
  {
    question: "Can you help with SEO and performance?",
    answer: "Absolutely. Every project I build is optimized for speed and search engines from the ground up. I also offer dedicated SEO audits and optimization services for existing platforms.",
  },
  {
    question: "What technologies do you specialize in?",
    answer: "I specialize in the modern JavaScript ecosystem (React, Next.js, Node.js, TypeScript) and established backend technologies like PHP and MySQL. I choose the best stack based on your specific project needs.",
  },
  {
    question: "How do we get started?",
    answer: "The process begins with a free consultation where we discuss your goals and requirements. After that, I'll provide a detailed proposal and project roadmap.",
  },
];

export function FAQ({ items = defaultFaqs }: { items?: FAQItem[] }) {
  return (
    <div className="max-w-3xl mx-auto">
      <Accordion type="single" collapsible className="w-full space-y-4">
        {items.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <AccordionItem
              value={`item-${index}`}
              className="bg-neutral-900/40 border border-neutral-800 rounded-2xl px-6 overflow-hidden hover:border-violet-500/30 transition-colors"
            >
              <AccordionTrigger className="text-left font-bold uppercase tracking-tight text-white hover:no-underline py-6">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 text-lg leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        ))}
      </Accordion>
    </div>
  );
}